import dayjs from "dayjs";

/**
 *
 * @param {string | Date | number | dayjs.Dayjs} dt
 * @param {string=} format
 */
export default function formatTime(dt, format = "YYYY-MM-DD HH:mm:ss") {
  if (!dt) {
    dt = dayjs();
  }
  if (typeof dt === "number") {
    dt = dt.toString();
    if (dt.length === 10) {
      dt = dt + "000";
    } else if (dt.length !== 13) {
      throw new Error("unknown timestamp: " + dt);
    }
    dt = parseInt(dt);
  }
  if (["number", "string"].includes(typeof dt)) {
    dt = dayjs(new Date(dt));
  } else if (dt instanceof Date) {
    dt = dayjs(dt);
  }
  return dt.format(format);
}
